
<div class="user-selection">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Select users for this project:</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [showLimit]="false" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="users.length" (onChange)="onListControlsChange($event)"></list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th></th>
            <th>Name</th>
            <th>Email</th>
            <th>Roles</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of displayedUsers">
            <td>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="user-selection-checkbox-{{user.id}}" [(ngModel)]="user.selected" [disabled]="user.disabled || disableAll" (change)="updateDirty()">
              </div>
            </td>
            <td>{{user.firstName}} {{user.lastName}}</td>
            <td>{{user.emailAddress}}</td>
            <td>{{user.roles}}</td>
          </tr>
          <tr *ngIf="users.length === 0">
            <td colspan="4">
              <p class="text-center empty-table-message">There are no users to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Selected Users:</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <div style="max-height: 250px; overflow-y: auto;">
        <table class="table table-responsive table-sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Roles</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of selectedUsers">
              <td>{{ user?.displayName }}</td>
              <td>{{ user?.emailAddress }}</td>
              <td>{{ user?.roles }}</td>
            </tr>
            <tr *ngIf="users.length === 0">
              <td colspan="3">
                <p class="text-center empty-table-message">There are no selected users</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>